import { downfile } from '@/common/common.js';
import { parseTime } from '@/utils/date';

// 计算元素的高度
export const mathEleHeight = (dom, botHeight) => {
  // 获取当前页面的高度
  let h = document.body.clientHeight;
  let index = dom.getBoundingClientRect().top;
  return h * 1 - index * 1 - botHeight * 1;
};

// 获取元素的各个值
export const getElementVale = (dom, ele) => {
  let data = dom.getBoundingClientRect()[ele];
  return data || 0;
};

// 测试项
export const checkOptionList = [
  { label: '全部', id: -1 },
  { label: '工况', id: 0 },
  { label: '油烟', id: 1 },
  { label: '在线', id: 2 },
];

// 编码

export const iconEncoding = () => {
  return [
    { name: '温度', coding: 'iconfont icon-wendu2' },
    { name: '废气', coding: 'iconfont icon-feiqi' },
    { name: '氧气', coding: 'iconfont icon-yangqi' },
    { name: '压力', coding: 'iconfont icon-yali1' },
    { name: '风速', coding: 'iconfont icon-fengsu' },
    { name: '湿度', coding: 'iconfont icon-shidu' },
    { name: '烟感', coding: 'iconfont icon-yangan' },
    { name: '化学', coding: 'iconfont icon-chemistry' },
    { name: '烟尘', coding: 'iconfont icon-iconfuzhi' },
    { name: '苯', coding: 'iconfont icon-benxiwuquchulv' },
    { name: '流量', coding: 'iconfont icon-liuliang' },
    { name: '镍', coding: 'iconfont icon-nie' },
    { name: '二氧化硫', coding: 'iconfont icon-eryanghualiu' },
    { name: '氨氮', coding: 'iconfont icon-andan' },
    { name: '甲烷', coding: 'iconfont icon-jiawan' },
    { name: 'PH', coding: 'iconfont icon-suanjiandu' },
    { name: '碳氢化合物', coding: 'iconfont icon-shiyongtanqinghuahewurongjihuanheganxi' },
    { name: '铜', coding: 'iconfont icon-tong' },
    { name: '污水', coding: 'iconfont icon-wushui' },
    { name: '总氮', coding: 'iconfont icon-zongdan' },
    { name: '铬', coding: 'iconfont icon-ge' },
    { name: 'cod', coding: 'iconfont icon-huaxuexuyangliang' },
    { name: '氯化氢', coding: 'iconfont icon-lvhuaqing' },
    { name: '一氧化碳', coding: 'iconfont icon-yiyanghuatan' },
    { name: '氮氧化物', coding: 'iconfont icon--' },
    { name: '总磷', coding: 'iconfont icon-linhuaqing' },
    { name: '悬浮物', coding: 'iconfont icon-xuanfuwu' },
    { name: '氢', coding: 'iconfont icon-qingqi' },
    { name: '氟化物', coding: 'iconfont icon-fuhuawu' },
    { name: '真空阀门', coding: 'iconfont icon-zhenkongfamen' },
    { name: '压差', coding: 'iconfont icon-yacha' },
    { name: 'PM2.5', coding: 'iconfont icon-PM' },
    { name: 'PM10', coding: 'iconfont icon-PM10' },
    { name: '风机', coding: 'iconfont icon-fengji' },
    { name: '噪音', coding: 'iconfont icon-zaoyin' },
    { name: '入口', coding: 'iconfont icon-icon_rukou' },
    { name: '出口', coding: 'iconfont icon-chukou' },
    { name: '风向', coding: 'iconfont icon-fengxiang' },
    { name: 'TSP', coding: 'iconfont icon-tsp' },
    { name: '压力', coding: 'iconfont icon-yali' },
  ];
};

// 获取公司创建年份和今年年份做成数组
export const createCompanyTime = (n, todayYear) => {
  let box = /^\d{4}$/;
  let arr = [];
  if (box.test(n)) {
    let num = Number(n);
    for (let i = todayYear; i >= num; --i) {
      arr.push(i);
    }
  }
  return arr;
};

// 导出数据
export const exportExcel = (companyId, gkid, startTime, endTime, self, type) => {
  let apis = 'exportExcel/GKOrYyOrZxHistoryData';
  if (type == 1) {
    apis = 'exportExcel/zxHourHistoryData';
  }
  // type:1低于2高于3全部
  let data = {
    companyId: companyId,
    gkSiteId: gkid, // 检测项id
    startTime: parseTime(new Date(startTime), '{y}-{m}-{d}'), // 开始时间
    endTime: parseTime(new Date(endTime), '{y}-{m}-{d}'), // 结束时间
  };
  self.$Spin.show();

  self.$http
    .post(self.ApiUrl + apis, data)
    .then(res => {
      self.$Spin.hide();
      if (res.data.extend.news == 0) {
        if (res.data.extend.src) {
          const url = res.data.extend.src;
          /** 下载excl文件
           * 	param : {res.data.extend.src} 链接
           * 	param :{url.substring(url.lastIndexOf('/')+1,url.lenght)}  文件名
           */
          downfile(res.data.extend.src, url.substring(url.lastIndexOf('/') + 1, url.lenght));
        }
      } else {
        self.$Message.warning({
          content: res.data.extend.msg || '暂无数据',
          duration: 3,
        });
      }
    })
    .catch(err => {
      self.$Spin.hide();
    });
};

// 计算时间有没有超过月数
export const overMonth = (startTime, endTime, num) => {
  let s = parseTime(startTime, '{y}-{m}-{d}')
    .split('-')
    .map(res => res * 1);
  let e = parseTime(endTime, '{y}-{m}-{d}')
    .split('-')
    .map(res => res * 1);

  let m = (e[0] - s[0]) * 12 + e[1] - s[1] + (e[2] - s[2]) / 30;
  return m <= num;
};
